/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateClientAccessTokenResponseEntity
 */
export interface GenerateClientAccessTokenResponseEntity {
    /**
     * アクセストークン
     * @type {string}
     * @memberof GenerateClientAccessTokenResponseEntity
     */
    accessToken: string;
    /**
     * スコープ
     * @type {string}
     * @memberof GenerateClientAccessTokenResponseEntity
     */
    scope: string;
    /**
     * 有効期限
     * @type {Date}
     * @memberof GenerateClientAccessTokenResponseEntity
     */
    expiresAt: Date;
}

/**
 * Check if a given object implements the GenerateClientAccessTokenResponseEntity interface.
 */
export function instanceOfGenerateClientAccessTokenResponseEntity(value: object): value is GenerateClientAccessTokenResponseEntity {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function GenerateClientAccessTokenResponseEntityFromJSON(json: any): GenerateClientAccessTokenResponseEntity {
    return GenerateClientAccessTokenResponseEntityFromJSONTyped(json, false);
}

export function GenerateClientAccessTokenResponseEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateClientAccessTokenResponseEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'scope': json['scope'],
        'expiresAt': (new Date(json['expiresAt'])),
    };
}

export function GenerateClientAccessTokenResponseEntityToJSON(json: any): GenerateClientAccessTokenResponseEntity {
    return GenerateClientAccessTokenResponseEntityToJSONTyped(json, false);
}

export function GenerateClientAccessTokenResponseEntityToJSONTyped(value?: GenerateClientAccessTokenResponseEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'scope': value['scope'],
        'expiresAt': ((value['expiresAt']).toISOString()),
    };
}

